var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCodeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    fill: "none",
    viewBox: "0 0 20 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5883 0h-2.7118c-.4477 0-.7931.3582-.7931.793 0 .435.3582.7931.7931.7931h2.7118v3.2235c0 .4477.3581.793.793.793s.7931-.3581.7931-.793V1.5989C19.1744.7163 18.4581 0 17.5755 0zM.7931 5.6155c.4477 0 .793-.3582.793-.7931V1.5989h2.7502c.4477 0 .793-.3581.793-.793s-.358-.7931-.793-.7931H1.599C.7163.0128 0 .729 0 1.6118v3.2234c0 .4477.3582.793.793.793zM4.3363 15.03H1.599v-3.2235c0-.4477-.3581-.793-.793-.793s-.7931.3581-.7931.793V15.03c0 .8826.7163 1.5989 1.599 1.5989h2.7245c.4477 0 .793-.3581.793-.7931 0-.4349-.358-.793-.793-.793zm14.0578-4.0165c-.4477 0-.793.3581-.793.793V15.03h-2.7118c-.4477 0-.7931.3581-.7931.7931 0 .4349.3582.793.7931.793h2.7118c.8826 0 1.5989-.7163 1.5989-1.5989v-3.2235c0-.4477-.3582-.793-.7931-.793z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.4702 2.5583H4.7968c-.8826 0-1.599.7163-1.599 1.599V6.127c0 .8826.7164 1.599 1.599 1.599h2.6734c.8826 0 1.599-.7164 1.599-1.599V4.1572c0-.8826-.7164-1.599-1.599-1.599m0 3.5688H4.7968V4.1572h2.6734zm9.082 6.2167v-1.9699c0-.8826-.7164-1.599-1.599-1.599h-2.6734c-.8826 0-1.5989.7164-1.5989 1.599v1.9699c0 .8826.7163 1.5989 1.5989 1.5989h2.6734c.8826 0 1.599-.7163 1.599-1.5989m-4.2724-1.9699h2.6734v1.9699h-2.6734zm-1.5989-4.8736h3.2234v1.599h-3.2234zm0-2.3024h5.8713v1.5989h-5.8713zM5.8457 9.4017h3.2235v1.599H5.8457zm-2.6478 2.3025h5.8713v1.5989H3.1979z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCodeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/code-icon.2d0d17cc6b47550b90c903dca2907089.svg";